import React, { useState, useEffect } from "react";
import "../Dashboard/dashboard.css";
import Leftbar from "../../components/Leftsidebar";
import moment from "moment";
import Topbar from "../../components/Topbar";
import { DashbaordInfo, MatchingToFundingConversion } from "../Utils/utils";
import Loaderspinner from "../../components/Loader";
import { Bar } from "react-chartjs-2";
import { useLocation } from "react-router-dom";
import { Analyticsdata, ProjectAnalyticsdata, InterestedUserAnalyticsdata, MatchedUserAnalyticsdata } from "../Utils/utils";
import { toast, ToastContainer } from "react-toastify";
import { Outlet, Navigate } from 'react-router-dom';
import { useNavigate } from "react-router-dom";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const Dashboard = () => {
  const navigate = useNavigate();
  const role = localStorage.getItem("role");

  const [loading, setLoading] = useState(false);
  const [showSidebar, setShowSidebar] = useState(false);
  const [dashboardDetails, setUserDashbaorddetails] = useState(null);
  const [activeView, setActiveView] = useState('lender');
  const [typeStatus, setTypeStatus] = useState("daily");
  const [typeStatus2, setTypeStatus2] = useState("daily");
  const [range, setRange] = useState(30);
  const [range2, setRange2] = useState(30);
  const [chartData, setChartData] = useState({ labels: [], datasets: [] });
  const [chartData2, setChartData2] = useState({ labels: [], datasets: [] });
  const [activeViewAnalytics, setActiveViewAnalytics] = useState('lender');
  const userType = activeViewAnalytics === "borrower" ? "raiser" : "deal";
  const [expandedRow, setExpandedRow] = useState(null);
  const dataList = activeView === 'lender' ? dashboardDetails?.recentLenders || [] : dashboardDetails?.recentRaisers || [];

  useEffect(() => {
    if (role == "transaction_cordinator") {
      // <Navigate to="/deals-assigned" replace />;
      navigate("/deals-assigned", { replace: true });
    }
  }, []);

  const handleSidebar = () => {
    setShowSidebar(!showSidebar);
  };

  const handleSidebarClose = () => {
    setShowSidebar(false);
  };

  const handleDahboard = async () => {
    let token = localStorage.getItem("token");

    if (!token) {
      console.error("No token found!");
      return;
    }

    try {
      setLoading(true)
      const response = await DashbaordInfo(token);
      setUserDashbaorddetails(response.data);
    } catch (error) {
      console.error("Error during Authme request:", error);
    } finally {
      setLoading(false)
    }
  };

  useEffect(() => {
    handleDahboard();
  }, []);

  const fetchData = async (type) => {
    try {
      setLoading(true);
      const res = await Analyticsdata(type, userType, range);
      const labels = res.data.map((item) => item.label);
      const counts = res.data.map((item) => item.count);

      setChartData({
        labels,
        datasets: [
          {
            label: "Listing Data",
            data: counts,
            backgroundColor: "rgba(75, 192, 192, 0.2)",
            borderColor: "rgba(75, 192, 192, 1)",
            borderWidth: 1,
          },
        ],
      });
    } catch (error) {
      toast.error(error?.message)
      console.error("Error fetching analytics data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (activeViewAnalytics == 'borrower' || activeViewAnalytics == 'lender') {
      fetchData(typeStatus);
    }
  }, [typeStatus, activeViewAnalytics == 'borrower', activeViewAnalytics == 'lender', range]);

  const fetchDataProjects = async (type) => {
    try {
      setLoading(true);
      const res = await ProjectAnalyticsdata(type, range);
      const labels = res.data.map((item) => item.label);
      const counts = res.data.map((item) => item.count);

      setChartData({
        labels,
        datasets: [
          {
            label: "Listing Data",
            data: counts,
            backgroundColor: "rgba(75, 192, 192, 0.2)",
            borderColor: "rgba(75, 192, 192, 1)",
            borderWidth: 1,
          },
        ],
      });
    } catch (error) {
      toast.error(error?.message)
      console.error("Error fetching analytics data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (activeViewAnalytics === 'project') {
      fetchDataProjects(typeStatus);
    }
  }, [typeStatus, activeViewAnalytics == 'project', range]);

  const fetchDataInterestedUsers = async (type) => {
    try {
      setLoading(true);
      const res = await InterestedUserAnalyticsdata(type, range);
      const labels = res.data.map((item) => item.label);
      const counts = res.data.map((item) => item.count);

      setChartData({
        labels,
        datasets: [
          {
            label: "Listing Data",
            data: counts,
            backgroundColor: "rgba(75, 192, 192, 0.2)",
            borderColor: "rgba(75, 192, 192, 1)",
            borderWidth: 1,
          },
        ],
      });
    } catch (error) {
      toast.error(error?.message)
      console.error("Error fetching analytics data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (activeViewAnalytics === 'user') {
      fetchDataInterestedUsers(typeStatus);
    }
  }, [typeStatus, activeViewAnalytics == 'user', range]);

  const fetchDataMatchedUsers = async (type) => {
    try {
      setLoading(true);
      const res = await MatchedUserAnalyticsdata(type, range);
      const labels = res.data.map((item) => item.label);
      const counts = res.data.map((item) => item.count);

      setChartData({
        labels,
        datasets: [
          {
            label: "Listing Data",
            data: counts,
            backgroundColor: "rgba(75, 192, 192, 0.2)",
            borderColor: "rgba(75, 192, 192, 1)",
            borderWidth: 1,
          },
        ],
      });
    } catch (error) {
      toast.error(error?.message)
      console.error("Error fetching analytics data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (activeViewAnalytics === 'match') {
      fetchDataMatchedUsers(typeStatus);
    }
  }, [typeStatus, activeViewAnalytics == 'match', range]);

  const options = {
    responsive: true,
    scales: {
      y: {
        beginAtZero: true,
      },
    },
  };





  const matchingAnaylytics = async (type) => {
    try {
      setLoading(true);
      const res = await MatchingToFundingConversion(type, range2);
      const labels = res.data.map((item) => item.label);
      const counts = res.data.map((item) => item.count);

      setChartData2({
        labels,
        datasets: [
          {
            label: "Listing Data",
            data: counts,
            backgroundColor: "rgba(75, 192, 192, 0.2)",
            borderColor: "rgba(75, 192, 192, 1)",
            borderWidth: 1,
          },
        ],
      });
    } catch (error) {
      toast.error(error?.message)
      console.error("Error fetching analytics data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // if (activeViewAnalytics === 'match') {
    matchingAnaylytics(typeStatus2);
    // }
  }, [typeStatus2, range2]);

  return (
    <>
      {loading && <Loaderspinner />}
      <div class="g-sidenav-show  bg-gray-100 min-vh-100">
        <div id="wrapper">
          <Leftbar showSidebar={showSidebar}
            handleSidebarClose={handleSidebarClose}
          />
          <main className="main-content border-radius-lg">
            <Topbar handleSidebar={handleSidebar} />
            <div className="header bg-color">
              <div className="container-fluid">
                <div className="header-body">

                  <div className="row pt-4">
                    <div className="col-xl-3 col-md-2 col-sm-12 mb-2">
                      <div className="card-div h-100">
                        <div>
                          <h6 className="card-title text-capitalize text-muted mt-0">Total Users</h6>
                          <span className="h6 font-weight-bold pt-0">{dashboardDetails ? dashboardDetails?.totalUsers : "0"}</span>
                        </div>
                        <div>
                          <img src="/img/user.svg" height='50px' width='50px' />
                        </div>
                      </div>
                    </div>

                    <div className="col-xl-3 col-md-2 col-sm-12 mb-2">
                      <div className="card-div h-100">
                        <div>
                          <h6 className="card-title text-capitalize text-muted mt-0">Total Lenders</h6>
                          <span className="h6 font-weight-bold pt-0">{dashboardDetails ? dashboardDetails?.lenders : "0"}</span>
                        </div>
                        <div>
                          <img src="/img/lenders.svg" height='50px' width='50px' />
                        </div>
                      </div>
                    </div>


                    <div className="col-xl-3 col-md-2 col-sm-12 mb-2">
                      <div className="card-div h-100">
                        <div>
                          <h6 className="card-title text-capitalize text-muted mt-0">Total Borrowers</h6>
                          <span className="h6 font-weight-bold pt-0">{dashboardDetails ? dashboardDetails?.raisers : "0"}</span>
                        </div>
                        <div>
                          <img src="/img/borrowers.svg" height='50px' width='50px' />
                        </div>
                      </div>
                    </div>

                    <div className="col-xl-3 col-md-2 col-sm-12 mb-2">
                      <div className="card-div h-100">
                        <div>
                          <h6 className="card-title text-capitalize text-muted mt-0">Total Projects</h6>
                          <span className="h6 font-weight-bold pt-0">{dashboardDetails ? dashboardDetails?.projects : "0"}</span>
                        </div>
                        <div>
                          <img src="/img/projects.svg" height='50px' width='50px' />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row" style={{ marginTop: "10px" }}>
                    <div className="col-xl-8 col-md-8">
                      <div className="card shadow-sm border-0" style={{ borderRadius: '12px' }}>
                        <div className="card-body">
                          <div className="d-flex justify-content-between align-items-center mb-3">
                            <h5 className="mb-0 fw-semibold">Analytics</h5>
                            <div style={{ display: 'flex' }}>
                              <div style={{ marginRight: '10px' }}>
                                <select
                                  className="custom-select-dropdown"
                                  value={typeStatus}
                                  onChange={(e) => setTypeStatus(e.target.value)}
                                >
                                  <option value="daily" className="option">Daily</option>
                                  <option value="weekly" className="option">Weekly</option>
                                  <option value="monthly" className="option">Monthly</option>
                                </select>
                              </div>
                              <div style={{ marginRight: '10px' }}>
                                <select
                                  className="custom-select-dropdown"
                                  value={range}
                                  onChange={(e) => setRange(e.target.value)}
                                >
                                  <option className="option">Range</option>
                                  <option value="30" className="option">30</option>
                                  <option value="12" className="option">12</option>
                                </select>
                              </div>
                              <div className="view-toggle">
                                <button
                                  style={{ fontSize: '12px' }}
                                  className={`toggle-btn ${activeViewAnalytics === 'lender' ? 'active' : ''}`}
                                  onClick={() => setActiveViewAnalytics('lender')}
                                >
                                  <i className="bi bi-grid-fill me-1"></i> Lender
                                </button>
                                <button
                                  style={{ fontSize: '12px' }}
                                  className={`toggle-btn ${activeViewAnalytics === 'borrower' ? 'active' : ''}`}
                                  onClick={() => setActiveViewAnalytics('borrower')}
                                >
                                  <i className="bi bi-list-ul me-1"></i> Borrower
                                </button>
                                <button
                                  style={{ fontSize: '12px' }}
                                  className={`toggle-btn ${activeViewAnalytics === 'project' ? 'active' : ''}`}
                                  onClick={() => setActiveViewAnalytics('project')}
                                >
                                  <i className="bi bi-grid-fill me-1"></i> Projects
                                </button>
                                <button
                                  style={{ fontSize: '12px' }}
                                  className={`toggle-btn ${activeViewAnalytics === 'user' ? 'active' : ''}`}
                                  onClick={() => setActiveViewAnalytics('user')}
                                >
                                  <i className="bi bi-grid-fill me-1"></i> Interested Lenders
                                </button>
                                <button
                                  style={{ fontSize: '12px' }}
                                  className={`toggle-btn ${activeViewAnalytics === 'match' ? 'active' : ''}`}
                                  onClick={() => setActiveViewAnalytics('match')}
                                >
                                  <i className="bi bi-grid-fill me-1"></i> Matched
                                </button>
                              </div>
                            </div>
                          </div>

                          {chartData?.labels?.length > 0 && chartData?.datasets?.length > 0 ? (
                            <div style={{ border: '1px solid #f5f5f5', borderRadius: '20px' }}>
                              <div className="card-body">
                                <Bar data={chartData} options={options} />
                              </div>
                            </div>
                          ) : (
                            <p className="mt-2">Data not available</p>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-4 col-md-4">
                      <div className="card shadow-sm border-0" style={{ borderRadius: '12px' }}>
                        <div className="card-body" style={{ maxHeight: '68vh', overflowY: 'auto' }}>
                          <div className="d-flex justify-content-between align-items-center mb-3">
                            <h5 className="mb-0 fw-semibold">Recent Logins</h5>
                            <div className="view-toggle">
                              <button
                                className={`toggle-btn ${activeView === 'lender' ? 'active' : ''}`}
                                onClick={() => setActiveView('lender')}
                              >
                                <i className="bi bi-grid-fill me-1"></i> Lender
                              </button>
                              <button
                                className={`toggle-btn ${activeView === 'borrower' ? 'active' : ''}`}
                                onClick={() => setActiveView('borrower')}
                              >
                                <i className="bi bi-list-ul me-1"></i> Borrower
                              </button>
                            </div>
                          </div>

                          <div style={{ maxHeight: '68vh', overflowY: 'auto' }}>
                            {dataList.length > 0 ? (
                              dataList.map((user, idx) => (
                                <div className="user-card mb-1" key={user.id}>
                                  <div style={{ padding: '4px 12px' }}>
                                    <div className="d-flex align-items-center justify-content-between">
                                      <div className="d-flex align-items-center">
                                        <img
                                          src={user?.about?.photo || '/img/deafult-user.svg'}
                                          className="avatar"
                                          alt="user"
                                          style={{ height: '32px', width: '32px' }}
                                        />
                                        <div className="mx-1">
                                          <div style={{ fontSize: '14px' }}>
                                            {user?.about?.name || 'N/A'} {user?.about?.lastname || ''}
                                          </div>
                                        </div>
                                      </div>

                                      <div>
                                        <div
                                          className="btn"
                                          style={{ color: '#99663A', fontSize: '14px', border: 'none' }}
                                          onClick={() => setExpandedRow(expandedRow === idx ? null : idx)}
                                        >
                                          {expandedRow === idx ? '▲' : '▼'}
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  {expandedRow === idx && (
                                    <div className="expanded-section">
                                      <div className="d-flex justify-content-between flex-wrap text-muted">
                                        <div style={{ fontSize: '12px' }}>Phone : {user?.phone || 'N/A'}</div>
                                      </div>
                                      <div className="d-flex justify-content-between flex-wrap text-muted">
                                        <div style={{ fontSize: '12px' }}>Email : {user?.email || 'N/A'}</div>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              ))
                            ) : (
                              <div className="text-muted mt-2">{activeView} data not available</div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-xl-8 col-md-8">
                      <div className="card shadow-sm border-0" style={{ borderRadius: '12px' }}>
                        <div className="card-body">
                          <div className="d-flex justify-content-between align-items-center mb-3">
                            <h5 className="mb-0 fw-semibold">Analytics</h5>
                            <div style={{ display: 'flex' }}>
                              <div style={{ marginRight: '10px' }}>
                                <select
                                  className="custom-select-dropdown"
                                  value={typeStatus2}
                                  onChange={(e) => setTypeStatus2(e.target.value)}
                                >
                                  <option value="daily" className="option">Daily</option>
                                  <option value="weekly" className="option">Weekly</option>
                                  <option value="monthly" className="option">Monthly</option>
                                </select>
                              </div>
                              <div style={{ marginRight: '10px' }}>
                                <select
                                  className="custom-select-dropdown"
                                  value={range2}
                                  onChange={(e) => setRange2(e.target.value)}
                                >
                                  <option className="option">Range</option>
                                  <option value="30" className="option">30</option>
                                  <option value="12" className="option">12</option>
                                </select>
                              </div>

                            </div>
                          </div>

                          {chartData2?.labels?.length > 0 && chartData2?.datasets?.length > 0 ? (
                            <div style={{ border: '1px solid #f5f5f5', borderRadius: '20px' }}>
                              <div className="card-body">
                                <Bar data={chartData2} options={options} />
                              </div>
                            </div>
                          ) : (
                            <p className="mt-2">Data not available</p>
                          )}
                        </div>
                      </div>
                    </div>


                  </div>

                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </>
  );
}
export default Dashboard;